import { createSelector } from 'reselect';

export const selectAlertUser = createSelector(
    state => state.alertUser,
    alertUser => alertUser,
);

export const selectProfileImage = createSelector(
    [selectAlertUser],
    alertUser => {
        return alertUser.profileImage || null;
    },
);
export const selectProfileImageThumbnail = createSelector(
    [selectAlertUser],
    alertUser => {
        return alertUser.profileImageThumbnail || null;
    },
);
